import CoreLayoutContainer from './CoreLayoutContainer';

export default CoreLayoutContainer;
